import './LiveChat.scss';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
interface LiveChatParameters {
  apiKey: string;
  avatar: string;
  greetingText: string;
  id: string;
  language: 'en' | 'sp';
  noMessageHistory: boolean;
  playSound: boolean;
  primaryColor: string;
  secondaryColor: string;
  title: string;
}
export default class LiveChat {
  mDiv: JQuery<HTMLElement>;

  private _chatPanel: JQuery<HTMLElement>;
  private _chatToggle: JQuery<HTMLElement>;
  private _slChatToggle: JQuery<HTMLElement>;
  private _hasLiveChat: boolean = false;
  private _chatParams: LiveChatParameters | string;

  constructor() {
    this._chatParams = this._parseUrlParams();
  }

  createLiveChat(): Promise<void> {
    var self = this;
    console.log('+++++ createLiveChat');
    return new Promise<void>((resolve, reject) => {
      if (self._hasLiveChat) {
        resolve();
        return;
      }

      self._hasLiveChat = true;
      window['recime-bot'] = this._chatParams;

      let slScript = document.createElement('script');
      slScript.setAttribute('id', 'recime-chatbot-script');
      slScript.setAttribute('src', 'https://webchat.smartloop.ai/shim.js');
      slScript.setAttribute('async', 'async');
      slScript.addEventListener('load', event => {
        setTimeout(() => {
          self._setupLiveChatDOM();
          resolve();
        }, 500);
      });
      document.getElementsByTagName('body')[0].appendChild(slScript);
    });
  }

  /* The code below does the following:
1. Removes the current live chat script and iframe
2. Sets the _hasLiveChat variable to true so that the iframe 
   is created again
3. Calls the createLiveChat() method to create again. */

  refreshLiveChatParams(): void {
    this._chatParams = this._parseUrlParams();
    $('#recime-chatbot-script').remove();
    $('#recime-chatbot').remove();
    this._hasLiveChat = true;
    this.createLiveChat();
  }

  // createSimpleLiveChat(): void {
  //     // TODO
  //     let windowFrame = $.param(this._chatParams); //id=ae820f6af663dd6305a3165ee15f6354&title=Help+Chat+Template+(v01.34+Lancelet)+DO+NOT+EDIT&apiKey=f7627f00cd8311ec8dc1057dfc93054d&language=en&primaryColor=%23c7179c&secondaryColor=%23ffffff&avatar=https%3A%2F%2Ficons.recime.io%2F1627946850.png&greetingText=Help&playSound=true&noMessageHistory=true&attachment=true&position=right
  //     let newIframe = document.createElement('iframe');
  //     newIframe.src = 'https://webchat.smartloop.ai/?' + windowFrame;
  //     this.mDiv.find('.live_chat_iframe').replaceWith(newIframe);
  //     // this.mDiv.find('.live_chat_iframe')[0].innerHTML =
  //     //     'https://webchat.smartloop.ai/?' + windowFrame;
  // }

  hideLiveChatPanel(): void {
    this._chatPanel?.removeClass('shown');
    this._swapChatToggleIcon();
  }

  hideLiveChat(userHiding): void {
    this._chatPanel?.removeClass('shown');
    this._chatToggle?.removeClass('shown');
    if (userHiding) {
      App.INSTANCE?.firehoseActivity(
        null,
        null,
        App.INSTANCE.appRouter?.lastRouteResolvedUrl(),
        App.INSTANCE?.CurrentUser.Id,
        'Support Chat',
        'Close',
        null,
      );
    }
  }

  showLiveChatToggle(): void {
    this._chatToggle.addClass('shown');
    this._swapChatToggleIcon();
  }

  showLiveChat(): void {
    if (!this._hasLiveChat) {
      this.createLiveChat()
        .then(() => {
          this._chatPanel.addClass('shown');
          webchat.open('Start');
          this.setupUser();
        })
        .catch(error => {
          // we couldnt create
          console.error(error);
          let confirmPanel = new ConfirmPopupPanel();
          App.INSTANCE.showTextMessage("We're sorry, our Live Chat Support is not configured yet.", 5000);
        });
    } else {
      this._chatPanel.addClass('shown');
      webchat.open('Start');
      this.setupUser();
    }

    App.INSTANCE?.firehoseActivity(
      null,
      null,
      App.INSTANCE.appRouter?.lastRouteResolvedUrl(),
      App.INSTANCE?.CurrentUser.Id,
      'Support Chat',
      'Open',
      null,
    );
  }

  // smartloop is handling undefined, blank or empty values
  setupUser(): void {
    webchat.setUser({
      first_name: App.INSTANCE.CurrentUser.Firstname,
      last_name: App.INSTANCE.CurrentUser.Lastname,
      country: App.INSTANCE.CurrentUser.Country,
      email: App.INSTANCE.CurrentUser.Email,
    });
  }

  private _swapChatToggleIcon(): void {
    if (this._chatPanel?.hasClass('shown')) {
      this._chatToggle?.html(
        $(
          HGEN.faicon({
            style: FontAwesomeConfigurations.ICON_XMARK,
          }),
        ),
      );
    } else {
      this._chatToggle.html(
        $(
          HGEN.faicon({
            class: `${FontAwesomeConfigurations.ICON_COMMENTS_DUOTONE} fa-swap-opacity`,
            primary: '#fff',
            secondary: '#fff',
            secondary_opacity: '0.4',
          }),
        ),
      );
    }
  }

  private _setupLiveChatDOM(): void {
    this.mDiv = $('#recime-chatbot');
    this._chatPanel = this.mDiv.find('#recime-messenger-root');
    this._slChatToggle = this.mDiv.find('.recime-launcher-frame');
    this._slChatToggle.hide();

    this._chatToggle = $(
      HGEN.tree({
        style: 'sl_chat_toggle',
      }),
    );

    this._chatToggle.css('background-color', this._chatParams.primaryColor);
    Accessibility.clickAndKeypress(this._chatToggle, () => {
      if (this._chatPanel.hasClass('shown')) {
        if (App.INSTANCE.CurrentUser.IsLoggedIn()) {
          this.hideLiveChat(true);
        } else {
          this.hideLiveChatPanel();
        }
      } else {
        this.showLiveChat();
        this._swapChatToggleIcon();
      }
    });
    // we are hiding the elements initially so that we can show them depending on where we are
    this.mDiv.append(this._chatToggle);
    this._swapChatToggleIcon();
  }

  private _parseUrlParams(): LiveChatParameters {
    let chatParams: LiveChatParameters | string = CrowdHub_App.CONFIG.LIVE_CHAT_URL;
    if (typeof chatParams === 'string' && chatParams != '') {
      let splitParams = CrowdHub_App.CONFIG.LIVE_CHAT_URL.split('{')[2].split('}')[0];
      splitParams = '{' + splitParams + '}';
      return JSON.parse(splitParams);
    } else if (typeof chatParams === 'object') {
      return chatParams;
    } else {
      return {};
    }
  }
}
